import { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { rejectNonAdminAdminSession } from "../utils/adminAuthGate";

export const PublicRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem("accessToken");
  const location = useLocation();

  if (token) {
    const companyPortalUrl = rejectNonAdminAdminSession();
    if (companyPortalUrl) {
      return <Navigate to="/login" replace state={{ companyPortalUrl }} />;
    }

    const previous = location.state?.from;
    return <Navigate to={previous || "/ticketing"} replace />;
  }

  return children;
};
